//import defaultmenu from "./defaultmenu";
//import menubuilder from "./menubuilder";
export {default as defaultmenu} from "./defaultmenu";
export {default as menubuilder} from "./menubuilder";
//export default {defaultmenu, menubuilder};



// WEBPACK FOOTER //
// ./src/menu/index.js